import { HttpClient } from '@angular/common/http';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { AVATAR_COLORS } from '@material-library';
import { Subscription, lastValueFrom } from 'rxjs';
import { ApiService } from 'src/app/core/api.service';
import { LoggerService } from 'src/app/core/logger.service';
import { UserService } from 'src/app/core/user.service';
import { SnackbarService } from 'src/app/shared/services/snackbar.service';
import { environment } from 'src/environments/environment';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Store } from '@ngrx/store';
import { Router } from '@angular/router';
import * as fromRoot from '../../reducers';
import { BlendEvent, PermissionActions, User } from 'src/app/shared/models';
import { BlendService } from 'src/app/shared/services/blend.service';


@Component({
  selector: 'app-branding',
  templateUrl: './branding.component.html',
  styleUrls: ['./branding.component.scss'],
})
export class BrandingComponent implements OnInit, OnDestroy {
  public linkTextColor: string = AVATAR_COLORS.primary;
  public headerColor: string = AVATAR_COLORS.secondaryContainer;
  public headerTextColor: string = AVATAR_COLORS.onSurface;
  public buttonTextColor: string = AVATAR_COLORS.white;
  public buttonPrimaryColor: string = AVATAR_COLORS.primary;

  public isPreviewDialog: boolean = false;
  public isSaveChangesDialog: boolean = false;
  public isFileLoading: boolean = false;
  public isFileUploaded: boolean = false;
  public imageUrl: string = '';
  public errcode: any;
  public showRemoveLogoButton: boolean;
  public showAlert: boolean = false;
  public AllowedFileTypes: any = [];
  public fileType: string = '';
  public isHeaderColorTemplate: boolean = false;
  public selectedColor: string = '';
  public isHeaderTextColorTemplate: boolean = false;
  public isLinkTextColorTemplate: boolean = false;
  public isButtonPrimaryColorTemplate: boolean = false;
  public isButtonTextColorTemplate: boolean = false;
  public color: any;
  public isLoading: boolean = false;
  public isHeaderColorDialogOpen: boolean = false;
  public isHeaderTextColorDialogOpen: boolean = false;
  public isLinkTextColorDialogOpen: boolean = false;
  public isButtonPrimaryColorDialogOpen: boolean = false;
  public isButtonTextColorDialogOpen: boolean = false;
  public isSmallScreen: boolean = false;
  public isConfirmed: boolean = false; public showAlertForSave: boolean = false;
  public isResetDefault: boolean = false;
  public isFullScreen: boolean = false;
  public cpWidth: string = "auto";

  private subscription: Subscription;
  private breakpointSubscription: Subscription;
  public showBranding: boolean;
  public permissionActions = PermissionActions;
  public user: User;

  constructor(
    private snackbarService: SnackbarService,
    private httpClient: HttpClient,
    private api: ApiService,
    public breakpointObserver: BreakpointObserver,
    private logger: LoggerService,
    private store: Store<fromRoot.State>,
    private userService: UserService,
    private router: Router,
    private blendService: BlendService
  ) { }

  async ngOnInit() {
    this.subscription = this.store
      .select(fromRoot.getAuthState)
      .subscribe((data) => {
        if (!data.authenticated) {
          this.user = new User();
          return;
        }
        if (data.user) {
          this.user = data.user;
          this.showBranding = (this.user.has_whitelabel && !this.user.is_multi_child && !this.user.is_multi_admin) || (this.user.has_whitelabel && (this.user.is_multi_admin || this.userService.checkPermission(this.permissionActions.MANAGE_BILLING)));
        }
        if(this.user.whitelabel.image_data){
          this.imageUrl = this.user.whitelabel.image_data;
          this.headerColor = this.user.whitelabel.header_primary_color;
          this.headerTextColor = this.user.whitelabel.header_text_color;
          this.buttonPrimaryColor = this.user.whitelabel.button_primary_color;
          this.buttonTextColor = this.user.whitelabel.button_text_color;
          this.linkTextColor = this.user.whitelabel.link_text_color;
        }
      });
      if (!this.imageUrl) {
        this.imageUrl = '';
      this.linkTextColor = AVATAR_COLORS.primary;
      this.headerColor = AVATAR_COLORS.secondaryContainer;
      this.headerTextColor = AVATAR_COLORS.onSurface;
      this.buttonTextColor = AVATAR_COLORS.white;
      this.buttonPrimaryColor = AVATAR_COLORS.primary;
      }

      

    if (!this.showBranding) {
      this.router.navigate(['settings', 'profile'])
    }

    this.breakpointSubscription = this.breakpointObserver
      .observe(['(max-width: 904px)'])
      .subscribe((state: BreakpointState) => {
        if (state.matches) {
          this.cpWidth = "378px";
          this.isSmallScreen = true;
          if (this.isHeaderColorTemplate) {
            this.isHeaderColorDialogOpen = true;
          } else if (this.isHeaderTextColorTemplate) {
            this.isHeaderTextColorDialogOpen = true;
          } else if (this.isButtonPrimaryColorTemplate) {
            this.isButtonPrimaryColorDialogOpen = true;
          } else if (this.isButtonTextColorTemplate) {
            this.isButtonTextColorDialogOpen = true;
          } else if (this.isLinkTextColorTemplate) {
            this.isLinkTextColorDialogOpen = true;
          }
          this.isFullScreen = true;
          if (this.isPreviewDialog) {
            this.isPreviewDialog = true;
          }
        } else {
          this.cpWidth = "258px";
          this.isSmallScreen = false;
          if (this.isHeaderColorTemplate) {
            this.isHeaderColorDialogOpen = false;
          } else if (this.isHeaderTextColorTemplate) {
            this.isHeaderTextColorDialogOpen = false;
          } else if (this.isButtonPrimaryColorTemplate) {
            this.isButtonPrimaryColorDialogOpen = false;
          } else if (this.isButtonTextColorTemplate) {
            this.isButtonTextColorDialogOpen = false;
          } else if (this.isLinkTextColorTemplate) {
            this.isLinkTextColorDialogOpen = false;
          }
          this.isFullScreen = false;
          if (this.isSaveChangesDialog) {
            this.isSaveChangesDialog = false;
          }
        }
      });
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.breakpointSubscription) {
      this.breakpointSubscription.unsubscribe();
    }
  }


  uploadFile = async (files: File[]) => {
    if (!files || files.length == 0) {
      this.isFileUploaded = false;
      this.imageUrl = null;
      this.showRemoveLogoButton = false;
      this.showAlert = false;
      return;
    }
    this.AllowedFileTypes = [
      'image/gif',
      'image/jpeg',
      'image/png',
      'image/svg',
    ];
    this.fileType = files[0].type;

    if (!this.AllowedFileTypes.includes(this.fileType)) {
      this.showAlert = true;
      return;
    }

    this.isFileLoading = true;

    try {
      const path = '/upload/whitelabel';
      const formData: FormData = new FormData();
      formData.append('file', files[0], files[0].name);
      const whitelabelResponse$ = this.httpClient.post(
        environment.imageconversionhost + path,
        formData
      );
      const result: { success: number; imgdata: string } = (await lastValueFrom(
        whitelabelResponse$
      )) as any;
      if (result.success) {
        this.imageUrl = result.imgdata;
        this.isFileUploaded = true;
        this.showRemoveLogoButton = true;
        this.showAlert = false;
        this.showAlertForSave = false;
      }
      this.snackbarService.showMessage(
        'success',
        'Logo successfully uploaded.'
      );
    } catch (error) {
      this.showAlert = false;
      this.snackbarService.showMessage(
        'critical',
        "Couldn't complete action. Try again."
      );
    } finally {
      this.isFileLoading = false;
    }
  };

  onPreviewClick = () => {
    this.isPreviewDialog = true;
  };

  onCancelClick = () => {
    this.isPreviewDialog = false;
    this.isSaveChangesDialog = false;
    this.isResetDefault = false;
  };
  onCloseClick = () => {
    this.isPreviewDialog = false;
    this.isSaveChangesDialog = false;
    this.isResetDefault = false;
  };

  onSaveChangesClick = () => {
    this.isSaveChangesDialog = true;
  };

  onSaveClick = async () => {
    if (!this.imageUrl) {
      this.showAlertForSave = true;
      this.isSaveChangesDialog = false;
      return;
    }
    try {
      await this.api.execute('uploadwhitelabel', {
        logoBase64: this.imageUrl,
        headerPrimaryColor: this.headerColor,
        headerTextColor: this.headerTextColor,
        buttonPrimaryColor: this.buttonPrimaryColor,
        buttonTextColor: this.buttonTextColor,
        linkTextColor: this.linkTextColor,
      });
      this.showAlertForSave = false;
      this.isSaveChangesDialog = false;
      this.snackbarService.showMessage(
        'success',
        'Settings successfully saved.'
      );
      this.logger.info('whitelabel header color: ' + this.headerColor);
      this.logger.info('whitelabel header text color: ' + this.headerTextColor);
      this.logger.info('whitelabel button color: ' + this.buttonPrimaryColor);
      this.logger.info('whitelabel button text color: ' + this.buttonTextColor);
      this.logger.info('whitelabel link text color: ' + this.linkTextColor);
      this.userService.refresh();
      this.blendService.track(BlendEvent.SAVE_BRANDING_CHANGES);
    } catch (error) {
      this.showAlertForSave = false;
      this.isSaveChangesDialog = false;
      this.snackbarService.showMessage(
        'critical',
        'Couldn’t save changes. Try again.'
      );
    }
  };

  // RESET TO DEFAULT START 
  private async setPreferencesToDefault() {
    try {
      await this.api.execute('uploadwhitelabel',
        {
          'logoBase64': '',
          'headerPrimaryColor': '',
          'headerTextColor': '',
          'buttonPrimaryColor': '',
          'buttonTextColor': '',
          'linkTextColor': '',
        });
      this.isResetDefault = false;
      this.imageUrl = '';
      this.linkTextColor = AVATAR_COLORS.primary;
      this.headerColor = AVATAR_COLORS.secondaryContainer;
      this.headerTextColor = AVATAR_COLORS.onSurface;
      this.buttonTextColor = AVATAR_COLORS.white;
      this.buttonPrimaryColor = AVATAR_COLORS.primary;

      this.userService.refresh();
      this.snackbarService.showMessage(
        'success',
        'Settings successfully saved.'
      );
      // this.userService.refresh();

    } catch (error) {
      this.isResetDefault = false;
      this.snackbarService.showMessage(
        'critical',
        'Couldn’t save changes. Try again.'
      );
    }
  }

  onResetDefaultClick = () => {
    this.isResetDefault = true;
  };



  onResetClick = () => {
    this.setPreferencesToDefault();
  };
  // RESET TO DEFAULT END

  onHeaderColorClick = async () => {
    if (this.isMenuOpen()) return;
    this.selectedColor = this.headerColor;
    this.isHeaderColorTemplate = true;
    this.isHeaderColorDialogOpen = true;
  }

  onHeaderTextColorClick = async () => {
    if (this.isMenuOpen()) return;
    this.selectedColor = this.headerTextColor;
    this.isHeaderTextColorTemplate = true;
    this.isHeaderTextColorDialogOpen = true;
  }

  onLinkColorClick = async () => {
    if (this.isMenuOpen()) return;
    this.selectedColor = this.linkTextColor;
    this.isLinkTextColorTemplate = true;
    this.isLinkTextColorDialogOpen = true;
  }

  onButtonPrimaryColorClick = async () => {
    if (this.isMenuOpen()) return;
    this.selectedColor = this.buttonPrimaryColor;
    this.isButtonPrimaryColorTemplate = true;
    this.isButtonPrimaryColorDialogOpen = true;
  }

  onButtonTextColorClick = async () => {
    if (this.isMenuOpen()) return;
    this.selectedColor = this.buttonTextColor;
    this.isButtonTextColorTemplate = true;
    this.isButtonTextColorDialogOpen = true;
  }

  onCancelButtonClick = async () => {
    this.isHeaderColorTemplate = false;
    this.isHeaderTextColorTemplate = false;
    this.isButtonPrimaryColorTemplate = false;
    this.isButtonTextColorTemplate = false;
    this.isLinkTextColorTemplate = false;
    this.isHeaderColorDialogOpen = false;
    this.isHeaderTextColorDialogOpen = false;
    this.isLinkTextColorDialogOpen = false;
    this.isButtonPrimaryColorDialogOpen = false;
    this.isButtonTextColorDialogOpen = false
  }

  onConfirmButtonClick = () => {
    this.isConfirmed = true;
    if (this.isHeaderColorTemplate) {
      this.isHeaderColorTemplate = false;
      this.headerColor = this.selectedColor;
      this.isHeaderColorDialogOpen = false;
    } else if (this.isHeaderTextColorTemplate) {
      this.isHeaderTextColorTemplate = false;
      this.headerTextColor = this.selectedColor;
      this.isHeaderTextColorDialogOpen = false;
    } else if (this.isButtonPrimaryColorTemplate) {
      this.isButtonPrimaryColorTemplate = false;
      this.buttonPrimaryColor = this.selectedColor;
      this.isButtonPrimaryColorDialogOpen = false;
    } else if (this.isButtonTextColorTemplate) {
      this.isButtonTextColorTemplate = false;
      this.buttonTextColor = this.selectedColor;
      this.isButtonTextColorDialogOpen = false;
    } else if (this.isLinkTextColorTemplate) {
      this.isLinkTextColorTemplate = false;
      this.linkTextColor = this.selectedColor;
      this.isLinkTextColorDialogOpen = false;
    } else {
      this.isConfirmed = false;
    }
    if (!this.isConfirmed) {
      this.snackbarService.showMessage(
        'critical',
        "Couldn’t save changes. Try again."
      );
    }
  }

  isMenuOpen = () => {
    return this.isHeaderColorTemplate ||
      this.isHeaderTextColorTemplate ||
      this.isButtonPrimaryColorTemplate ||
      this.isButtonTextColorTemplate ||
      this.isLinkTextColorTemplate;
  }
}

